import { create } from 'zustand';

interface MoveState {
    isSequenceMoving: boolean;
    startSequenceMove: (chapterSequenceId: any) => void;
    stopSequenceMove: () => void;
    chapterSequenceId: any;
    isChapterMoving: boolean;
    startChapterMove: (chapterId: any) => void;
    stopChapterMove: () => void;
    chapterId: any;
}

export const useMoveStore = create<MoveState>((set) => ({
    isSequenceMoving: false,
    chapterSequenceId: null,
    chapterId: null,
    startSequenceMove: (chapterSequenceId: any) => set({ isSequenceMoving: true, chapterSequenceId }),
    stopSequenceMove: () => set({ isSequenceMoving: false, chapterSequenceId: null }),
    isChapterMoving: false,
    startChapterMove: (chapterId: any) => set({ isChapterMoving: true, chapterId }),
    stopChapterMove: () => set({ isChapterMoving: false, chapterId: null }),
}));